import { LspClient } from '../../Components/Editor/Monaco/LspClient';

export const programLspClient = new LspClient();

let unloadListenerAdded = false;

export function ensureProgramLspClientDisposedOnUnload(): void {
  if (unloadListenerAdded) return;
  window.addEventListener('beforeunload', () => {
    programLspClient.dispose();
  });
  unloadListenerAdded = true;
}
